document.addEventListener('DOMContentLoaded', function(){
    var menuAccordionBtns = document.querySelectorAll('.mobile-nav-item button.buddha-mobile-nav-button');   

    if(menuAccordionBtns.length > 0) {
        menuAccordionBtns.forEach(function(btn){
            btn.addEventListener('click', function(){
                this.classList.toggle("active");
                
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                    this.ariaExpanded = "false";
                } else {
                    this.ariaExpanded = "true";
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        });
    }
});

// Links new window
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}